<template>
  <div id="theme--tuktuk__checkout__shipping">
    <div
      v-if="
        data.addShipping &&
        shippingType == 'automated' &&
        data.payload.address &&
        (data.courierOptionDataFinal || data.courierOptionDataCargo) &&
        (data.courierOptionDataFinal.length > 0 || data.courierOptionDataCargo.length > 0) &&
        !shippingHideView
      "
      class="theme--tuktuk__checkout__shipping__automated theme--tuktuk__card"
    >
      <div class="theme--tuktuk__container">
        <div class="theme--tuktuk__checkout__shipping__automated__header">
          <h2 class="theme--tuktuk__title">{{ data.titleShipping }}</h2>
          <!-- Pre Order Info -->
          <!-- <p class="m-0 fs-14 fw-400" style="color: #15171C; opacity: 0.4; font-size: 14px;">From West Jakarta to Semarang</p> -->
          <div v-if="data.preOrder != undefined && data.preOrder.isActive" class="pre-order alert flex items-center m-0" style="font-size: 14px;" :style="{ marginBottom: data.preOrder.isActive ? '16px !important' : '0px'  }">
            <img src="@/assets/icons/TuktukTheme/calendar-wait.svg" alt="Calendar" />
            <span class="shipped-from-text fw-400">{{ preOrderText }}</span>
          </div>
          <div v-if="!isMultipleShipments && !shippingHideView" class="fm-flex fm-items-center shipped-from-card">
            <div class="fm-flex fm-items-center fm-size-5">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10.0001 18C10.0001 18 16.261 12.4348 16.261 8.26087C16.261 4.80309 13.4579 2 10.0001 2C6.54234 2 3.73926 4.80309 3.73926 8.26087C3.73926 12.4348 10.0001 18 10.0001 18Z" stroke="#EB435B" stroke-width="1.5"/>
                <path d="M12.0004 8.00013C12.0004 9.1047 11.105 10.0001 10.0004 10.0001C8.89581 10.0001 8.00038 9.1047 8.00038 8.00013C8.00038 6.89556 8.89581 6.00013 10.0004 6.00013C11.105 6.00013 12.0004 6.89556 12.0004 8.00013Z" stroke="#EB435B" stroke-width="1.5"/>
              </svg>
            </div>
            <span v-if="getShippedFrom" class="shipped-from-text">
              Dikirim dari <span class="fm-capitalize">{{ getShippedFrom }}</span>
            </span>
          </div>
        </div>
        <div v-if="isHasRegularShipping" class="group/shipment-regular fm-bg-white fm-flex fm-flex-col fm-rounded fm-outline fm-outline-1 -fm-outline-offset-1 fm-outline-outline-main" style="padding: 8px;">
          <div v-if="isHasCargoShipping" class="fm-flex fm-justify-between" style="cursor: pointer;" @click="selectedCourierType = 'regular'">
            <div class="fm-flex" style="gap: 8px;">
              <img src="@/assets/icons/illustration-cod-shipping-cost.svg" alt="regular-icon" width="32">
              <div class="fm-flex fm-flex-col">
                <p class="fs-12 fw-500 m-0 medium">{{ $t("common.regular") }}</p>
                <p class="fs-12 fw-400 m-0 regular">{{ $t("common.generalShipmentServices") }}.</p>
              </div>
            </div>
            <vs-radio
              :key="deliveryCourierPrice"
              val="regular"
              v-model="selectedCourierType"
              class="theme--tuktuk__radio theme--tuktuk__checkout__shipping__automated__list__provider__radio courierOptionsWithPrice"
            >

            </vs-radio>
          </div>
          <div v-if="selectedCourierType === 'regular' || !isHasCargoShipping" class="theme--tuktuk__checkout__shipping__automated__list">
            <hr v-if="isHasCargoShipping" class="tuktuk" />
            <div
              v-for="options in data.courierOptionDataFinal"
              :key="options.value + data.payload.payment"
              class="theme--tuktuk__checkout__shipping__automated__list__provider"
            >
              <vs-radio
                :val="options.value"
                v-model="deliveryCourierPrice"
                :disabled="isShippingUnsupported(options)"
                class="theme--tuktuk__radio theme--tuktuk__checkout__shipping__automated__list__provider__radio courierOptionsWithPrice"
              >
                <div class="theme-tuktuk-shipping-courier-and-shipFrom-address"  @click="!isShippingUnsupported(options) && handleShippingSelection(options.value, 'regular')">
                  <div v-if="isCheapest(options.value,data.courierOptionDataFinal) && isShippingUnsupported(options) && options.unsupported" class="tuktuk-courier-and-cheapest-wrapper flex">
                   <div class="flex" style="gap: 12px;">
                     <img
                         width="16px"
                         style="object-fit: contain;"
                         :alt="options.key"
                         :src="baseUrl+shippingCourierItems[options.key].imageSrc"
                       />
                       <div class="flex flex-column" style="margin-left: 4px;">
  
                        <div v-if="isCheapest(options.value,data.courierOptionDataFinal) && !isShippingUnsupported(options)" style="width: fit-content;">
                          <span class="cheapest-label tuktuk-theme">{{ $t("common.cheapest") }}</span>
                        </div>
                        <div class="theme--tuktuk__checkout__shipping__automated__list__provider__radio__left">                    
                          <span :style="{color: isShippingUnsupported(options) ? '#BFCEE0' : '#203551'}" :class="deliveryCourierPrice == options.value ? 'active-text' : ''">{{ options.label.split('-').length ? options.label.split('-')[0]+'-'+options.label.split('-')[1] : '' }}</span>
                        </div>
                        <p v-if="isShippingUnsupported(options)" class="fm-font-normal !fm-text-neutral-secondary-text fm-text-body-sm sm:fm-text-body-lg mb-0 address-unsupported-text">
                          Alamat tidak terjangkau
                        </p>
                        <p v-if="options.estimate_delivery && !isShippingUnsupported(options)" class="shipping-address m-0" :class="deliveryCourierPrice == options.value ? 'active-text' : ''">Estimasi {{ options.estimate_delivery }}</p>
                        </div>
                   </div>
                  </div>
                  <div v-else class="tuktuk-courier-and-cheapest-wrapper flex">
                    <div class="theme--tuktuk__checkout__shipping__automated__list__provider__radio__left" style="height: auto; gap: 12px;">
                      <img
                        width="30px"
                        :alt="options.key"
                        :src="baseUrl+shippingCourierItems[options.key].imageSrc"
                      />
                      <div class="flex flex-column">
                        <div class="flex">
                          <span :style="{color: isShippingUnsupported(options) ? '#BFCEE0' : '#203551'}" :class="deliveryCourierPrice == options.value ? 'active-text' : ''">{{ options.label.split('-').length ? options.label.split('-')[0]+'-'+options.label.split('-')[1] : '' }}</span>
                          <div v-if="isCheapest(options.value,data.courierOptionDataFinal) && !isShippingUnsupported(options)">
                            <span class="cheapest-label tuktuk-theme ml-1">{{ $t("common.cheapest") }}</span>
                          </div>
                        </div>
                        <p v-if="isShippingUnsupported(options)" class="fm-font-normal !fm-text-neutral-secondary-text fm-text-body-sm sm:fm-text-body-lg mb-0 address-unsupported-text">
                          Alamat tidak terjangkau
                        </p>
                        <p v-if="options.estimate_delivery && !isShippingUnsupported(options)" class="shipping-address m-0" :class="deliveryCourierPrice == options.value ? 'active-text' : ''">Estimasi {{ options.estimate_delivery }}</p>
                      </div>
                    </div>
                  </div>
                </div>  
                <div class="theme--tuktuk__checkout__shipping__automated__list__provider__radio__rigth">
                  <div v-if="isShippingUnsupported(options)" class="unsupported-badge">
                    <img src="@/assets/icons/x-circle-contained.svg" alt="icon" style="width: 14px; height: 14px;">
                    <span class="fm-text-error-800 fm-text-caption fm-font-medium">
                      {{ options.unsupported ? 'COD & NON COD' : 'COD'}}
                    </span>
                  </div>
                  <div v-else class="fm-flex fm-flex-col tuktuk__right__ctn" :class="deliveryCourierPrice == options.value ? 'active-text' : ''">
                    {{ options.label2.split('-').length > 2 ?  options.label2.split('-')[2] : 'Rp0' }}
                      <p v-if="isMultipleShipments && options.shipFromAddress && options.shipFromAddress.CITY_NAME && !shippingHideView" class="multiship-text" :class="deliveryCourierPrice == options.value ? 'active-text' : ''">
                        Dikirim dari <span class="fm-capitalize">{{ options.shipFromAddress.CITY_NAME.toLowerCase()}}</span>
                      </p>
                  </div>
                </div>
              </vs-radio>
            </div>
            <div v-if="data.errors['deliveryCourierPrice']" class="invalid-feedback" >
              {{ data.errors["deliveryCourierPrice"] }}
            </div>
          </div>
        </div>
        <div v-if="isHasCargoShipping" class="group/shipment-regular fm-bg-white fm-flex fm-flex-col fm-rounded fm-outline fm-outline-1 -fm-outline-offset-1 fm-outline-outline-main" style="padding: 8px; margin-top: 16px;">
          <div v-if="isHasRegularShipping" class="fm-flex fm-justify-between" style="cursor: pointer;" @click="selectedCourierType = 'cargo'">
            <div class="fm-flex" style="gap: 8px;">
              <img src="@/assets/icons/illustration-undelivered.svg" alt="regular-icon" width="32">
              <div class="fm-flex fm-flex-col">
                <div class="fm-flex fm-items-center" style="gap: 4px;">
                  <p class="fs-12 fw-500 m-0 medium">{{ $t("common.cargo") }}</p>
                  <vs-tooltip>
                    <svg id="info-tooltip" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99961 14.3996C11.5342 14.3996 14.3996 11.5342 14.3996 7.99961C14.3996 4.46499 11.5342 1.59961 7.99961 1.59961C4.46499 1.59961 1.59961 4.46499 1.59961 7.99961C1.59961 11.5342 4.46499 14.3996 7.99961 14.3996ZM7.19961 7.99961C7.19961 8.44144 7.55778 8.79961 7.99961 8.79961C8.44144 8.79961 8.79961 8.44144 8.79961 7.99961V4.79961C8.79961 4.35778 8.44144 3.99961 7.99961 3.99961C7.55778 3.99961 7.19961 4.35778 7.19961 4.79961V7.99961ZM7.19961 10.7996C7.19961 11.2414 7.55778 11.5996 7.99961 11.5996C8.44144 11.5996 8.79961 11.2414 8.79961 10.7996C8.79961 10.3578 8.44144 9.99961 7.99961 9.99961C7.55778 9.99961 7.19961 10.3578 7.19961 10.7996Z" fill="#6C7E95"/>
                    </svg>
                    <template #tooltip>
                      <div class="info-tooltip-text" style="width: 212px; text-align: left;">
                        <span>Paket dengan berat <strong>&lt; 10kg</strong> dikenakan ongkir <strong>10kg.</strong></span>
                        <span v-if="isSAPCargoAvailable"> Untuk SAP, paket dikenakan ongkir minimal sesuai ketentuan SAP</span>
                      </div>
                    </template>
                  </vs-tooltip>
                </div>
                <p class="fs-12 fw-400 m-0 regular">{{ $t("common.cargoSubtitle") }}.</p>
              </div>
            </div>
            <vs-radio
              :key="deliveryCourierPrice"
              v-if="isHasRegularShipping"
              val="cargo"
              v-model="selectedCourierType"
              class="theme--tuktuk__radio theme--tuktuk__checkout__shipping__automated__list__provider__radio courierOptionsWithPrice"
            >
            </vs-radio>
          </div>
          <div v-if="selectedCourierType === 'cargo' || !isHasRegularShipping" class="theme--tuktuk__checkout__shipping__automated__list">
            <hr v-if="isHasRegularShipping" class="tuktuk" />
            <div
              v-for="(options) in data.courierOptionDataCargo"
              :key="options.value + data.payload.payment"
              class="theme--tuktuk__checkout__shipping__automated__list__provider cargo"
            >
              <vs-radio
                :val="options.value"
                v-model="deliveryCourierPrice"
                :disabled="isShippingUnsupported(options)"
                class="theme--tuktuk__radio theme--tuktuk__checkout__shipping__automated__list__provider__radio courierOptionsWithPrice"
              >
                <div class="theme-tuktuk-shipping-courier-and-shipFrom-address" @click="!isShippingUnsupported(options) && handleShippingSelection(options.value, 'regular')">
                  <div v-if="isCheapest(options.value,data.courierOptionDataCargo) && isShippingUnsupported(options) && options.unsupported" class="tuktuk-courier-and-cheapest-wrapper flex">
                   <div class="flex" style="gap: 12px;">
                     <img
                         width="16px"
                         style="object-fit: contain;"
                         :alt="options.key"
                         :src="baseUrl+options.imageSrc"
                       />
                       <div class="flex flex-column" style="margin-left: 4px;">
  
                        <div v-if="isCheapest(options.value,data.courierOptionDataCargo) && !isShippingUnsupported(options)" style="width: fit-content;">
                          <span class="cheapest-label tuktuk-theme">{{ $t("common.cheapest") }}</span>
                        </div>
                        <div class="theme--tuktuk__checkout__shipping__automated__list__provider__radio__left">                    
                          <span :style="{color: isShippingUnsupported(options) ? '#BFCEE0' : '#203551'}" :class="deliveryCourierPrice == options.value ? 'active-text' : ''">{{ options.label2}}</span>
                        </div>
                        <p v-if="isShippingUnsupported(options)" class="fm-font-normal !fm-text-neutral-secondary-text fm-text-body-sm sm:fm-text-body-lg mb-0 address-unsupported-text">
                          Alamat tidak terjangkau
                        </p>
                        <p v-if="options.estimate_delivery && !isShippingUnsupported(options)" class="shipping-address m-0" :class="deliveryCourierPrice == options.value ? 'active-text' : ''">Estimasi {{ options.estimate_delivery }}</p>
                        </div>
                   </div>
                  </div>
                  <div v-else class="tuktuk-courier-and-cheapest-wrapper flex">
                    <div class="theme--tuktuk__checkout__shipping__automated__list__provider__radio__left" style="height: auto; gap: 12px;">
                      <img
                        width="30px"
                        :alt="options.key"
                        :src="baseUrl+options.imageSrc"
                      />
                      <div class="flex flex-column">
                        <div class="flex">
                          <span :style="{color: isShippingUnsupported(options) ? '#BFCEE0' : '#203551'}" :class="deliveryCourierPrice == options.value ? 'active-text' : ''">{{ options.label2}}</span>
                          <div v-if="isCheapest(options.value,data.courierOptionDataCargo) && !isShippingUnsupported(options)">
                            <span class="cheapest-label tuktuk-theme ml-1">{{ $t("common.cheapest") }}</span>
                          </div>
                        </div>
                        <p v-if="isShippingUnsupported(options)" class="fm-font-normal !fm-text-neutral-secondary-text fm-text-body-sm sm:fm-text-body-lg mb-0 address-unsupported-text">
                          Alamat tidak terjangkau
                        </p>
                        <p v-if="options.estimate_delivery && !isShippingUnsupported(options)" class="shipping-address m-0" :class="deliveryCourierPrice == options.value ? 'active-text' : ''">Estimasi {{ options.estimate_delivery }}</p>
                      </div>
                    </div>
                  </div>
                </div>  
                <div class="theme--tuktuk__checkout__shipping__automated__list__provider__radio__rigth">
                  <div v-if="isShippingUnsupported(options)" class="unsupported-badge">
                    <img src="@/assets/icons/x-circle-contained.svg" alt="icon" style="width: 14px; height: 14px;">
                    <span class="fm-text-error-800 fm-text-caption fm-font-medium">
                      {{ options.unsupported ? 'COD & NON COD' : 'COD'}}
                    </span>
                  </div>
                  <div v-else class="fm-flex fm-flex-col tuktuk__right__ctn" :class="deliveryCourierPrice == options.value ? 'active-text' : ''">
                    {{ options.label.split('-').length > 2 ?  options.label.split('-')[2] : 'Rp0' }}
                    <p v-if="isMultipleShipments && options.shipFromAddress && options.shipFromAddress.CITY_NAME && !shippingHideView" class="multiship-text" :class="deliveryCourierPrice == options.value ? 'active-text' : ''">
                      Dikirim dari <span class="fm-capitalize">{{ options.shipFromAddress.CITY_NAME.toLowerCase()}}</span>
                    </p>
                  </div>
                </div>
              </vs-radio>              
            </div>
            <div v-if="data.errors['deliveryCourierPrice']" class="invalid-feedback" >
              {{ data.errors["deliveryCourierPrice"] }}
            </div>            
          </div>
        </div>      
      </div>
    </div>

    <!-- SHIPPING FLAT AND FREE-->
    <div
      v-if="data.addShipping && shippingType !== 'automated'"
      class="theme--tuktuk__checkout__shipping__flat-free theme--tuktuk__card"
    >
      <div class="theme--tuktuk__container">
        <h2 class="theme--tuktuk__title">{{ data.titleShipping }}</h2>
        <div class="theme--tuktuk__checkout__shipping__flat-free__content">
          <!-- FLAT -->
          <template v-if="shippingType == 'flat'">
            <p style="flex: 1 1 auto; text-align: left;">
              {{ $t("common.shipping") }} {{ shippingType }}
            </p>
            <p v-if="shippingType == 'flat' && flatShippingPrice" class="number-price">
              Rp{{ flatShippingPrice | g_number_format }}
            </p>
          </template>
          <!-- FREE -->
          
          <template v-if="shippingType == 'free'">
            <p class="free-shippingType-title" style="flex: 1 1 auto; text-align: left;">
              {{ shippingType }} {{ $t("common.shipping") }}
            </p>
            <p class="flat-free-title number-price">Rp0</p>
          </template>

          <!-- Strikethrough Price -->
           <p v-if="data.isShowStrikethrough && ((flatShippingPrice || 0) < (freeDeliveryPrice || 0))" class="strikethrough-price">
            Rp{{ freeDeliveryPrice | g_number_format }}
          </p>
        </div>
      </div>
    </div>
    <!-- END SHIPPING -->
  </div>
</template>

<script>
import config from "../../../../config.js";
import { get } from "lodash";
import axios from 'axios'
export default {
  props: ["data", "user", "shippingCourierItems"],
  data() {
    return {
      config,
      baseUrl: config.api.replace("/api", ""),
      deliveryCourierPrice: "",
      freeDeliveryPrice: '',
    };
  },
  components: {},
  watch: {
     'data.payload.payment': {
      handler() {
        const currentSelection = [
          ...(this.isHasCargoShipping ? this.data.courierOptionDataCargo : []),
          ...(this.isHasRegularShipping ? this.data.courierOptionDataFinal : []),
        ].find(c => c.value === this.deliveryCourierPrice)

        // reselect unavailable courier after change cod / non-cod
        if (!currentSelection) {
          let courierOptions = []
          let courierType = ''

          if (this.selectedCourierType === 'cargo') {
            courierOptions = this.isHasCargoShipping ? [...this.data.courierOptionDataCargo] : [...this.data.courierOptionDataFinal]
            courierType = this.isHasCargoShipping ? 'cargo' : 'regular'
          }
          else if (this.selectedCourierType === 'regular') {
            courierOptions = this.isHasRegularShipping ? [...this.data.courierOptionDataFinal] : [...this.data.courierOptionDataCargo]
            courierType = this.isHasRegularShipping ? 'regular' : 'cargo'
          }

          const lowestCourierPrice = this.getCheapestCourier(courierOptions)
          if (lowestCourierPrice) this.handleShippingSelection(lowestCourierPrice.value, courierType)
        }
      },
    },
    "data.deliveryCourierPrice": {
      handler() {       
        this.deliveryCourierPrice = this.data.deliveryCourierPrice;
      },
    },
    deliveryCourierPrice: {
      async handler() {
        let price = this.deliveryCourierPrice;    
        if (price) {
          let sellerOriginId = null;
          let courierOptions = this.data.courierOptionDataFinal
          if (this.selectedCourierType === 'cargo') courierOptions = this.data.courierOptionDataCargo
          courierOptions.forEach(option => {
            if (option.value == price) {
              sellerOriginId = option.origin_id;
            }
          });
          price = price.split("==");
          let priceLabel = courierOptions.find(
            (x) => x.value == this.deliveryCourierPrice
          );
          if (priceLabel) {
            priceLabel = priceLabel.label.split("-");
            this.data.payload.deliveryCourier = price[0];
            this.data.payload.deliveryPrice = price[1];
            this.data.payload.sellerOriginId = sellerOriginId;
            this.data.payload.deliveryType = priceLabel[1].trim()
              ? priceLabel[1].trim()
              : "REG";
            this.$forceUpdate();
          }
        }
      },
      deep: true,
    },
    'data.payload.address': {
      async handler() {
        await this.getStrikeThroughPrice()
      },
      deep: true,
    },
  },
  methods: {
    async getStrikeThroughPrice(){
      let val = this.data.payload.address
      if (this.data.isShowStrikethrough && val && val.customerAUTOFILL) {
        let weight = this.data.shippingWeight / 1000
        if (weight < 1) {
          weight = 1
        }
        let shipFromAddress = this.data.multipleShipFrom && this.data.multipleShipFrom.length > 0 ? this.data.multipleShipFrom[0] : this.data.shipFrom
        let splitshipfrom = shipFromAddress.split('-');
        let origin = splitshipfrom.length > 0 ? splitshipfrom[0] : shipFromAddress
        let origin_id = splitshipfrom.length > 2 ? splitshipfrom[splitshipfrom.length-1] : splitshipfrom[0];      

        if (this.data.multiShipFromAddress && this.data.multiShipFromAddress[origin_id] && this.data.multiShipFromAddress[origin_id].address) {
          origin_id=this.data.multiShipFromAddress[origin_id].address.PICKUP_AUTOFILL
        }

        let destination_to = val.customerAUTOFILL
        const to = val.DESTINATION_CODE
        let res = await axios.get(this.config.shippingUrl + 'order/allEstimatePublic', { params: { username: this.user.username, origin_id: origin_id, destination_id: destination_to, from: origin, to: to, weight: weight, courier:"jne" } })
        if (res.data.success) {
          const firstCourier = Object.keys(res.data.data).filter(key => !key.toLowerCase().includes('cargo')).reduce(
            (courier, nextCourierKey) => {
              if (!courier.price) return res.data.data[nextCourierKey];
              return courier;
            },
            {},
          );
          this.freeDeliveryPrice = get(firstCourier, 'price', "");
        } 
        this.$forceUpdate();
      } else {
        this.freeDeliveryPrice = ''
      }
    },
    isCheapest(value, optionsData) {
      const prices = optionsData
        .filter(option => !this.isShippingUnsupported(option))
        .map(option => parseInt(option.value.split('==')[1] || '0'));

      const currentPrice = parseInt(value.split('==')[1] || '0');
      return Math.min(...prices) == currentPrice;
    },
    changeCouriePrice(type = 'regular') {
      let price = this.deliveryCourierPrice;
      if (price) {
        let courierOptions = this.data.courierOptionDataFinal
        if (type === 'cargo') courierOptions = this.data.courierOptionDataCargo
        console.log(courierOptions, type, price, "courierOptions")
        //for getting origin id for the seller address
        let sellerOriginId = null;
        courierOptions.forEach(option => {
          if (option.value == price) {
            sellerOriginId = option.origin_id;
          }
        });
        price = price.split("==");
        let priceLabel = courierOptions.find(
          (x) => x.value == this.deliveryCourierPrice
        );
        priceLabel = priceLabel.label.split("-");
        this.data.payload.sellerOriginId = sellerOriginId;
        this.data.payload.deliveryCourier = price[0];
        this.data.payload.deliveryPrice = price[1];
        this.data.payload.deliveryType = priceLabel[1].trim()
          ? priceLabel[1].trim()
          : "REG";
        this.$forceUpdate();
      }
    },
    isShippingUnsupported(shippingOption, skipCheckCODPayment = false) {      
      const isUnsupportedCOD = skipCheckCODPayment
        ? shippingOption.unsupported_cod
        : (this.data.payload.payment === 'COD' && shippingOption.unsupported_cod)

      return this.data.isShippingCoverageCheckEnabled && (
        shippingOption.unsupported || isUnsupportedCOD
      );
    },
     getCheapestCourier(options) {
      const selectableOptions = options.filter(option => !this.isShippingUnsupported(option))
      return selectableOptions.reduce((next, current) => {
        const currentPrice = parseInt(current.value.split('==')[1] || '0')
        const nextPrice = parseInt(next.value.split('==')[1] || '0')
        return currentPrice < nextPrice ? current : next;
      }, selectableOptions[0])
    },   
     handleShippingSelection(optionValue, type = 'regular') {
      this.deliveryCourierPrice = optionValue;
      this.changeCouriePrice(type);
    },
  },
  computed: {
     getShippedFrom() {
      let courierOptions = this.data.courierOptionDataFinal
      if (this.selectedCourierType === 'cargo') courierOptions = this.data.courierOptionDataCargo

      if (courierOptions && courierOptions[0] && courierOptions[0].shipFromAddress) {
        return courierOptions[0].shipFromAddress.CITY_NAME.toLowerCase() || ''
      }

      return Object.values(this.data.multiShipFromAddress)[0].CITY_NAME.toLowerCase() || ''
    },
    isMultipleShipments() {

      let courierOptions = this.data.courierOptionDataFinal
      if (this.selectedCourierType === 'cargo') courierOptions = this.data.courierOptionDataCargo
      
      const addressShipments = new Set(courierOptions.map(courier => courier.shipFromAddress.CITY_NAME || ''))
      return addressShipments.size > 1
    },
    isSAPCargoAvailable() {
      return !!this.data.courierOptionDataCargo.filter(item => item.key === 'SapCargo').length
    },
    selectedCourierType: {
      get() {
        if (this.data.shippingCourierTypesCargo.includes(this.data.payload.deliveryCourier)) return 'cargo'
        if (this.isHasCargoShipping && !this.isHasRegularShipping) return 'cargo'
        return 'regular'
      },
      set(type) {
        let courierOptions = this.data.courierOptionDataFinal || []
        if (type === 'cargo') courierOptions = this.data.courierOptionDataCargo || []

        const lowestCourierPrice = this.getCheapestCourier(courierOptions);
        if (lowestCourierPrice) this.handleShippingSelection(lowestCourierPrice.value, type)
      }
    },
    isHasCargoShipping() {
      const hasCargo = this.data.isPaymentTypeHaveDifferentValue && this.data.payload.payment === 'COD'
        ? (this.data.shippingCOD.hasCargoShipping || false)
        : (this.data.hasCargoShipping || false)
      
      return hasCargo && (this.data.courierOptionDataCargo || []).length > 0
    },
    isHasRegularShipping() {
      // handle old product before cargo
      const codHasRegularShipping = typeof this.data.shippingCOD.hasRegularShipping === 'undefined'
        ? true
        : this.data.shippingCOD.hasRegularShipping

      const hasRegular = this.data.isPaymentTypeHaveDifferentValue && this.data.payload.payment === 'COD'
        ? (codHasRegularShipping || false)
        : (this.data.hasRegularShipping || false)
      
      return hasRegular && (this.data.courierOptionDataFinal || []).length > 0
    },
    isPaymentCOD: {
      get() {
        return this.data.payload.payment === 'COD';
      }
    },

    shippingType: {
      get() {
        if (this.isPaymentCOD) {
           return this.data.shippingCOD.shippingType;
        }
        return this.data.shippingType;
      }
    },

    flatShippingPrice: {
      get() {
        if (this.isPaymentCOD) {
           return this.data.shippingCOD.flatShippingPrice || 0;
        }
        return this.data.flatShippingPrice || 0;
      }
    },
    preOrderText() {
      return this.$t('common.preOrder').replace(/x/g, this.data.preOrder.packagingDueDay);
    },
    shippingHideView() {
      return this.data.isPaymentTypeHaveDifferentValue && this.data.payload.payment === 'COD'
        ? (this.data.shippingCOD.shippingHideView || false)
        : (this.data.shippingHideView || false)
    }
  },
  mounted() {
    this.deliveryCourierPrice = this.data.deliveryCourierPrice;
  },
};
</script>

<style lang="scss" scoped>
.cheapest-label.tuktuk-theme {
  background: #EB435B1A;
  color: #EB435B;
  padding: 2px 4px;
  border-radius: 4px;
  height: 20px;
  font-size: 10px;
  font-family: TiktokDisplayMedium;
  align-items: center;
}
.courierOptionsWithPrice {
  justify-content: space-between;
  align-items: center;
  h6.types-ofcourier {
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.02em;
    text-align: left;
  }
  p.shipping-address {
    font-weight: 400;
    font-size: 12px;
    line-height: 19.2px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #6C7E95;
    font-family: TikTokDisplayRegular;
  }
  h6.shipping-price {
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.02em;
    text-align: left;
  }
  .unsupported-badge {
    display: flex;
    align-items: center;
    gap: 2px;
    height: 22px;
    padding: 4px 6px;
    font-size: 11px;
    font-weight: 500;
    color: #E12121;
    background-color: #FFE3E3;
    border-radius: 4px;
    font-family: inter;
    width: max-content;
  }
}
p {
  &.medium {
    font-weight: 500;
    font-style: normal;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: -0.24px;
    font-family: TiktokDisplayMedium;
    color: #203551;
  }
  &.regular {
    font-weight: 400;
    font-style: normal;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: -0.24px;
    font-family: TiktokDisplayRegular;
    color: #6C7E95;
  }
}
hr.tuktuk {
  width: 100%;
  border-top: 1px solid #E0E9F4;
  margin-top: 8px;
  margin-bottom: 0;
  padding-bottom: 0;
}
.theme--tuktuk__checkout__shipping__automated__list {
  row-gap: 8px !important;
}
.theme--tuktuk__checkout__shipping__automated__list > * {
  border-bottom: 1px solid #E0E9F4;
  padding-bottom: 8px;
}

.theme--tuktuk__checkout__shipping__automated__list > *:first-child {
  border-bottom: none;
}
.theme--tuktuk__checkout__shipping__automated__list.cargo > *:nth-child(2) {
  border-bottom: none;
}
.theme--tuktuk__checkout__shipping__automated__list > *:last-child {
  border-bottom: none;
}
.info-tooltip-text {
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  line-height: 18px; /* 150% */
  letter-spacing: -0.026px;
  width: 212px;
  text-align: left;
  padding: 7px 6px;
}
.vs-tooltip-content {
  height: 16px;
}
.shipped-from-card {
  height: 32px;
  padding: 10px 8px;
  gap: 2px;
  border-radius: 4px;
  border: 1px solid rgba(235, 67, 91, 0.15);
  background: rgba(235, 67, 91, 0.05);
  margin-bottom: 16px;
}
.shipped-from-text {
  color: #EB435B;
  font-family: TiktokDisplayRegular;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
  letter-spacing: -0.24px;
}
.multiship-text {
  color:  #6C7E95;
  text-align: right;
  font-family: TikTokDisplayRegular;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  letter-spacing: -0.24px;
  margin-bottom: 0;
}
.tuktuk__right__ctn {
  align-items: end;
  font-family: TiktokDisplayMedium;
}
.active-text {
  color: #EB435B !important;
}
.theme--tuktuk__title {
  margin-bottom: 16px !important;
}
#theme--tuktuk__checkout #theme--tuktuk__checkout__shipping .pre-order {
  padding: 8px;
  height: 36px;
}
.address-unsupported-text {
  font-family: TiktokDisplayRegular;
  margin-top: 0;
}
</style>
<style lang="scss">
.vs-tooltip.notArrow.top {
  padding: 8px;  
  border-radius: 8px;
  font-size: 13px;
  &:after {
    display: block !important;    
  }
  @media (max-width: 767px) {
    &:after {
      left: 43% !important;
    }
  }
}
</style>
